"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allIcons = void 0;
var React = require("react");
var admin_1 = require("./icons/admin");
var alert_1 = require("./icons/alert");
var arrow_1 = require("./icons/arrow");
var ambulance_1 = require("./icons/ambulance");
var badge_1 = require("./icons/badge");
var basket_1 = require("./icons/basket");
var bathTub_1 = require("./icons/bathTub");
var bed_1 = require("./icons/bed");
var boiler_1 = require("./icons/boiler");
var brokenLink_1 = require("./icons/brokenLink");
var bulb_1 = require("./icons/bulb");
var car_1 = require("./icons/car");
var cart_1 = require("./icons/cart");
var chart_1 = require("./icons/chart");
var checkRounded_1 = require("./icons/checkRounded");
var chevronLeft_1 = require("./icons/chevronLeft");
var chevronRight_1 = require("./icons/chevronRight");
var calendar_1 = require("./icons/calendar");
var chevronUp_1 = require("./icons/chevronUp");
var chevronDown_1 = require("./icons/chevronDown");
var clock_1 = require("./icons/clock");
var coins_1 = require("./icons/coins");
var coinPlus_1 = require("./icons/coinPlus");
var coinsWhite_1 = require("./icons/coinsWhite");
var contract_1 = require("./icons/contract");
var debug_1 = require("./icons/debug");
var dishwasher_1 = require("./icons/dishwasher");
var droplet_1 = require("./icons/droplet");
var drops_1 = require("./icons/drops");
var dRotate_1 = require("./icons/dRotate");
var electricalOutlet_1 = require("./icons/electricalOutlet");
var employees_1 = require("./icons/employees");
var energy_1 = require("./icons/energy");
var engineer_1 = require("./icons/engineer");
var entrance_1 = require("./icons/entrance");
var environment_1 = require("./icons/environment");
var exit_1 = require("./icons/exit");
var externalLink_1 = require("./icons/externalLink");
var facebook_1 = require("./icons/facebook");
var faceSad_1 = require("./icons/faceSad");
var faceSmiley_1 = require("./icons/faceSmiley");
var faucet_1 = require("./icons/faucet");
var fireHose_1 = require("./icons/fireHose");
var flowerWater_1 = require("./icons/flowerWater");
var garbageDisposal_1 = require("./icons/garbageDisposal");
var gift_1 = require("./icons/gift");
var glassWater_1 = require("./icons/glassWater");
var globe_1 = require("./icons/globe");
var hand_1 = require("./icons/hand");
var handshake_1 = require("./icons/handshake");
var heart_1 = require("./icons/heart");
var hidden_1 = require("./icons/hidden");
var home_1 = require("./icons/home");
var homeTemperature_1 = require("./icons/homeTemperature");
var homeWater_1 = require("./icons/homeWater");
var hotTub_1 = require("./icons/hotTub");
var instagram_1 = require("./icons/instagram");
var irrigation_1 = require("./icons/irrigation");
var kettle_1 = require("./icons/kettle");
var leakingPipe_1 = require("./icons/leakingPipe");
var lifebouy_1 = require("./icons/lifebouy");
var mail_1 = require("./icons/mail");
var man_1 = require("./icons/man");
var man2_1 = require("./icons/man2");
var map_1 = require("./icons/map");
var maximiseLoads_1 = require("./icons/maximiseLoads");
var medium_1 = require("./icons/medium");
var megaphone_1 = require("./icons/megaphone");
var menu_1 = require("./icons/menu");
var meter_1 = require("./icons/meter");
var minus_1 = require("./icons/minus");
var mouse_1 = require("./icons/mouse");
var network_1 = require("./icons/network");
var office_1 = require("./icons/office");
var officeTemp_1 = require("./icons/officeTemp");
var payment_1 = require("./icons/payment");
var pen_1 = require("./icons/pen");
var person_1 = require("./icons/person");
var pin_1 = require("./icons/pin");
var play_1 = require("./icons/play");
var plus_1 = require("./icons/plus");
var pond_1 = require("./icons/pond");
var pound_1 = require("./icons/pound");
var preasureWasher_1 = require("./icons/preasureWasher");
var product_1 = require("./icons/product");
var rainWaterTank_1 = require("./icons/rainWaterTank");
var refresh_1 = require("./icons/refresh");
var results_1 = require("./icons/results");
var returnIcon_1 = require("./icons/returnIcon");
var scale_1 = require("./icons/scale");
var settings_1 = require("./icons/settings");
var shaving_1 = require("./icons/shaving");
var shower_1 = require("./icons/shower");
var sink_1 = require("./icons/sink");
var sinkhole_1 = require("./icons/sinkhole");
var star_1 = require("./icons/star");
var stopwatch_1 = require("./icons/stopwatch");
var swimmingPool_1 = require("./icons/swimmingPool");
var tap_1 = require("./icons/tap");
var tBrushing_1 = require("./icons/tBrushing");
var thumbUp_1 = require("./icons/thumbUp");
var times_1 = require("./icons/times");
var toilet_1 = require("./icons/toilet");
var translate_1 = require("./icons/translate");
var turf_1 = require("./icons/turf");
var twitter_1 = require("./icons/twitter");
var typeCounter_1 = require("./icons/typeCounter");
var typeInput_1 = require("./icons/typeInput");
var typeMultiple_1 = require("./icons/typeMultiple");
var typeSlider_1 = require("./icons/typeSlider");
var urinal_1 = require("./icons/urinal");
var usaMap_1 = require("./icons/usaMap");
var userSwitch_1 = require("./icons/userSwitch");
var van_1 = require("./icons/van");
var visible_1 = require("./icons/visible");
var wallet_1 = require("./icons/wallet");
var washing_1 = require("./icons/washing");
var washingmachine_1 = require("./icons/washingmachine");
var waterbutt_1 = require("./icons/waterbutt");
var waterCoins_1 = require("./icons/waterCoins");
var waterEfficient_1 = require("./icons/waterEfficient");
var watering_1 = require("./icons/watering");
var worker_1 = require("./icons/worker");
var wrench_1 = require("./icons/wrench");
var youtube_1 = require("./icons/youtube");
var co2_1 = require("./icons/co2");
var download_1 = require("./icons/download");
var downloadApp_1 = require("./icons/downloadApp");
var onlineSafety_1 = require("./icons/onlineSafety");
var virtualPlumber_1 = require("./icons/virtualPlumber");
var tree_1 = require("./icons/tree");
var videoChat_1 = require("./icons/videoChat");
var videoChat2_1 = require("./icons/videoChat2");
var blockedPipe_1 = require("./icons/blockedPipe");
var knowledge_1 = require("./icons/knowledge");
var snow_1 = require("./icons/snow");
var useWhite_1 = require("./icons/useWhite");
var chartDown_1 = require("./icons/chartDown");
var chartEqual_1 = require("./icons/chartEqual");
var lock_1 = require("./icons/lock");
var unlock_1 = require("./icons/unlock");
var bell_1 = require("./icons/bell");
var leaf_1 = require("./icons/leaf");
var fr_FR_1 = require("./flags/fr-FR");
var en_GB_1 = require("./flags/en-GB");
var en_AU_1 = require("./flags/en-AU");
var ro_RO_1 = require("./flags/ro-RO");
var cy_GB_1 = require("./flags/cy-GB");
var lv_LV_1 = require("./flags/lv-LV");
var da_DK_1 = require("./flags/da-DK");
var hi_IN_1 = require("./flags/hi-IN");
var vi_VN_1 = require("./flags/vi-VN");
exports.allIcons = {
    admin: admin_1.default,
    alert: alert_1.default,
    arrow: arrow_1.default,
    ambulance: ambulance_1.default,
    badge: badge_1.default,
    basket: basket_1.default,
    bathTub: bathTub_1.default,
    bed: bed_1.default,
    boiler: boiler_1.default,
    brokenLink: brokenLink_1.default,
    bulb: bulb_1.default,
    car: car_1.default,
    cart: cart_1.default,
    chart: chart_1.default,
    chartEqual: chartEqual_1.default,
    chartDown: chartDown_1.default,
    checkRounded: checkRounded_1.default,
    calendar: calendar_1.default,
    chevronLeft: chevronLeft_1.default,
    chevronRight: chevronRight_1.default,
    chevronUp: chevronUp_1.default,
    chevronDown: chevronDown_1.default,
    clock: clock_1.default,
    coins: coins_1.default,
    coinPlus: coinPlus_1.default,
    coinsWhite: coinsWhite_1.default,
    contract: contract_1.default,
    debug: debug_1.default,
    dishwasher: dishwasher_1.default,
    droplet: droplet_1.default,
    drops: drops_1.default,
    dRotate: dRotate_1.default,
    electricalOutlet: electricalOutlet_1.default,
    employees: employees_1.default,
    energy: energy_1.default,
    engineer: engineer_1.default,
    entrance: entrance_1.default,
    environment: environment_1.default,
    exit: exit_1.default,
    externalLink: externalLink_1.default,
    facebook: facebook_1.default,
    faceSad: faceSad_1.default,
    faceSmiley: faceSmiley_1.default,
    faucet: faucet_1.default,
    fireHose: fireHose_1.default,
    flowerWater: flowerWater_1.default,
    garbageDisposal: garbageDisposal_1.default,
    gift: gift_1.default,
    glassWater: glassWater_1.default,
    globe: globe_1.default,
    hand: hand_1.default,
    handshake: handshake_1.default,
    heart: heart_1.default,
    hidden: hidden_1.default,
    home: home_1.default,
    homeTemperature: homeTemperature_1.default,
    homeWater: homeWater_1.default,
    hotTub: hotTub_1.default,
    instagram: instagram_1.default,
    irrigation: irrigation_1.default,
    kettle: kettle_1.default,
    leakingPipe: leakingPipe_1.default,
    lifebouy: lifebouy_1.default,
    mail: mail_1.default,
    man: man_1.default,
    man2: man2_1.default,
    map: map_1.default,
    maximiseLoads: maximiseLoads_1.default,
    medium: medium_1.default,
    megaphone: megaphone_1.default,
    menu: menu_1.default,
    meter: meter_1.default,
    minus: minus_1.default,
    mouse: mouse_1.default,
    network: network_1.default,
    office: office_1.default,
    officeTemp: officeTemp_1.default,
    payment: payment_1.default,
    pen: pen_1.default,
    person: person_1.default,
    pin: pin_1.default,
    play: play_1.default,
    plus: plus_1.default,
    pond: pond_1.default,
    pound: pound_1.default,
    preasureWasher: preasureWasher_1.default,
    product: product_1.default,
    rainWaterTank: rainWaterTank_1.default,
    refresh: refresh_1.default,
    results: results_1.default,
    return: returnIcon_1.default,
    scale: scale_1.default,
    settings: settings_1.default,
    shaving: shaving_1.default,
    shower: shower_1.default,
    sink: sink_1.default,
    sinkhole: sinkhole_1.default,
    star: star_1.default,
    stopwatch: stopwatch_1.default,
    swimmingPool: swimmingPool_1.default,
    tap: tap_1.default,
    tBrushing: tBrushing_1.default,
    thumbUp: thumbUp_1.default,
    times: times_1.default,
    toilet: toilet_1.default,
    translate: translate_1.default,
    turf: turf_1.default,
    twitter: twitter_1.default,
    typeCounter: typeCounter_1.default,
    typeInput: typeInput_1.default,
    typeMultiple: typeMultiple_1.default,
    typeSlider: typeSlider_1.default,
    urinal: urinal_1.default,
    usaMap: usaMap_1.default,
    userSwitch: userSwitch_1.default,
    van: van_1.default,
    visible: visible_1.default,
    wallet: wallet_1.default,
    washing: washing_1.default,
    washingmachine: washingmachine_1.default,
    waterbutt: waterbutt_1.default,
    waterCoins: waterCoins_1.default,
    waterEfficient: waterEfficient_1.default,
    watering: watering_1.default,
    worker: worker_1.default,
    wrench: wrench_1.default,
    youtube: youtube_1.default,
    co2: co2_1.default,
    download: download_1.default,
    downloadApp: downloadApp_1.default,
    onlineSafety: onlineSafety_1.default,
    virtualPlumber: virtualPlumber_1.default,
    tree: tree_1.default,
    videoChat: videoChat_1.default,
    videoChat2: videoChat2_1.default,
    blockedPipe: blockedPipe_1.default,
    knowledge: knowledge_1.default,
    snow: snow_1.default,
    useWhite: useWhite_1.default,
    bell: bell_1.default,
    frFR: fr_FR_1.default,
    enGB: en_GB_1.default,
    enAU: en_AU_1.default,
    roRO: ro_RO_1.default,
    cyGB: cy_GB_1.default,
    lvLV: lv_LV_1.default,
    hiIN: hi_IN_1.default,
    daDK: da_DK_1.default,
    viVN: vi_VN_1.default,
    lock: lock_1.default,
    unlock: unlock_1.default,
    leaf: leaf_1.default,
};
var IconRoot = function (props) {
    var icon = props.icon;
    var iconExists = exports.allIcons.hasOwnProperty(icon);
    if (iconExists) {
        var SpecificIcon = exports.allIcons[icon];
        return React.createElement(SpecificIcon, __assign({}, props));
    }
    var FallbackIcon = exports.allIcons.times;
    return React.createElement(FallbackIcon, __assign({}, props));
};
exports.default = IconRoot;
//# sourceMappingURL=list.js.map